import { render, staticRenderFns } from "./team.events.pub.vue?vue&type=template&id=6f9ed2b5&scoped=true&"
import script from "./team.events.pub.vue?vue&type=script&lang=js&"
export * from "./team.events.pub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ed2b5",
  null
  
)

export default component.exports